export default "__VITE_ASSET__1a823be1__"